module.exports = __webpack_public_path__ + "img/BS.8ec1337d.svg";